import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/dre-happy.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "app-team-switch-loader__content" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "app-team-switch-loader__dre",
    src: _imports_0,
    alt: "dre"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "app-team-switch-loader__title" }, "Switching organisations"),
  /*#__PURE__*/_createElementVNode("p", { class: "app-team-switch-loader__description" }, "Hang in there! Taking you to the right place!"),
  /*#__PURE__*/_createElementVNode("div", { class: "app-team-switch-loader__spinner" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "app-team-switch-loader__first-dot" }),
    /*#__PURE__*/_createElementVNode("div", { class: "app-team-switch-loader__second-dot" }),
    /*#__PURE__*/_createElementVNode("div", { class: "app-team-switch-loader__third-dot" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppOverlay = _resolveComponent("AppOverlay")!

  return (_openBlock(), _createBlock(_component_AppOverlay, { class: "app-team-switch-loader" }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}